import { useState } from 'react';
import { ImagePlus, Loader2, Trash2, ArrowUp, ArrowDown } from 'lucide-react';
import { toast } from 'sonner';
import { Input } from '../../ui/input';
import { Button } from '../../ui/button';
import { RUNTIME_BACKEND_URL } from '../../../lib/backendUrl';
import { adSrc } from '../landing/AdBlocks';

const API = `${RUNTIME_BACKEND_URL}/api/hesap`;
const PLACES = [
  { key: 'slider', label: 'Üst – Kayan Banner' },
  { key: 'middle', label: 'Orta – Modüllerin altı' },
  { key: 'bottom', label: 'Alt – İletişimin altı' },
];

const AdRow = ({ ad, idx, total, patch, remove, move }) => (
  <div className="border rounded-lg p-3 flex flex-col sm:flex-row gap-3" data-testid={`ad-row-${idx}`}>
    <img src={adSrc(ad.image_url)} alt="" className="w-full sm:w-44 h-24 object-cover rounded-md border" />
    <div className="flex-1 space-y-2">
      <div className="grid sm:grid-cols-2 gap-2">
        <Input value={ad.title || ''} onChange={e => patch({ title: e.target.value })} placeholder="Başlık (isteğe bağlı)" data-testid={`ad-title-${idx}`} />
        <Input value={ad.link || ''} onChange={e => patch({ link: e.target.value })} placeholder="Tıklanınca açılacak link (https://...)" data-testid={`ad-link-${idx}`} />
      </div>
      <Input value={ad.description || ''} onChange={e => patch({ description: e.target.value })} placeholder="Açıklama (isteğe bağlı)" data-testid={`ad-desc-${idx}`} />
      <div className="flex flex-wrap items-center gap-2">
        <select value={ad.placement} onChange={e => patch({ placement: e.target.value })} className="h-9 rounded-md border px-2 text-sm bg-transparent" data-testid={`ad-placement-${idx}`}>
          {PLACES.map(p => <option key={p.key} value={p.key}>{p.label}</option>)}
        </select>
        <label className="flex items-center gap-1 text-xs cursor-pointer">
          <input type="checkbox" checked={ad.active !== false} onChange={e => patch({ active: e.target.checked })} className="accent-emerald-600" data-testid={`ad-active-${idx}`} />
          Yayında
        </label>
        <div className="ml-auto flex gap-1">
          <Button type="button" variant="ghost" size="sm" disabled={idx === 0} onClick={() => move(-1)}><ArrowUp className="h-3.5 w-3.5" /></Button>
          <Button type="button" variant="ghost" size="sm" disabled={idx === total - 1} onClick={() => move(1)}><ArrowDown className="h-3.5 w-3.5" /></Button>
          <Button type="button" variant="ghost" size="sm" className="text-red-600" onClick={remove} data-testid={`ad-remove-${idx}`}><Trash2 className="h-3.5 w-3.5" /></Button>
        </div>
      </div>
    </div>
  </div>
);

export const AdsTab = ({ value, onChange, token }) => {
  const ads = value.ads || [];
  const [busy, setBusy] = useState(false);
  const setAds = (arr) => onChange({ ...value, ads: arr });

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append('file', file);
      const r = await fetch(`${API}/site-settings/ad-image`, { method: 'POST', headers: { Authorization: `Bearer ${token}` }, body: fd });
      const d = await r.json();
      if (!r.ok) throw new Error(d.detail || 'Görsel yüklenemedi');
      setAds([...ads, { id: `new-${Date.now()}`, image_url: d.image_url, title: '', description: '', link: '', placement: 'slider', active: true }]);
      toast.success('Reklam eklendi — kaydetmeyi unutmayın');
    } catch (e) { toast.error(e.message); }
    finally { setBusy(false); }
  };

  const move = (idx, d) => {
    const arr = [...ads];
    [arr[idx], arr[idx + d]] = [arr[idx + d], arr[idx]];
    setAds(arr);
  };

  return (
    <div className="space-y-3">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-sm text-slate-500">Tanıtım sayfasındaki reklam alanları. Üstteki kayan banner için geniş (ör. 1500×500) görseller önerilir.</p>
        <label className="inline-flex items-center gap-1.5 text-sm font-medium px-3 py-2 rounded-md bg-emerald-600 hover:bg-emerald-700 text-white cursor-pointer" data-testid="ad-add-btn">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <ImagePlus className="h-4 w-4" />} Reklam Görseli Ekle
          <input type="file" accept="image/png,image/jpeg,image/webp" className="hidden" disabled={busy}
            onChange={e => { upload(e.target.files?.[0]); e.target.value = ''; }} data-testid="ad-image-input" />
        </label>
      </div>
      {ads.length === 0 && <p className="text-xs text-slate-400 italic">Henüz reklam yok.</p>}
      {ads.map((ad, idx) => (
        <AdRow key={ad.id} ad={ad} idx={idx} total={ads.length}
          patch={p => setAds(ads.map((a, i) => (i === idx ? { ...a, ...p } : a)))}
          remove={() => setAds(ads.filter((_, i) => i !== idx))}
          move={d => move(idx, d)} />
      ))}
    </div>
  );
};
